import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HTTPStatus } from 'src/app/CommonService/app-token-handler';
import { DataService } from 'src/app/CommonService/data.service';
import { CommonService } from 'src/app/Shared/common.service';
import saveAs from 'file-saver'
import DiffMatchPatch from
  'diff-match-patch'
  ;
import { HttpEvent } from '@angular/common/http';
import { ClauseMasterDetails } from '../Requisition/create-gtcrequisition/create-gtcrequisition.component';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { FileUploadComponent } from 'src/app/Out-Of-Application/file-upload/file-upload.component';
import { ClauseAuditTrailComponent } from 'src/app/Out-Of-Application/clause-audit-trail/clause-audit-trail.component';
export interface DialogData {
  Count: any;
  fieldName: string;
  IsFormEditable: boolean;
  IsTQLLeader: boolean;
  IsSingleValue: boolean;

  FirmID: any;
  IsShownApprovalButtons: boolean;
  CombineListOfData: Array<any>,
  RecordStatus: number;
  IsNewRequest: boolean;
  ClauseList: Array<{
    ClauseNo: string, PaceID: string, EntityName: string,
    CreatedOn: string, ClauseDetailsList: Array<any>, ClauseStatus: number
  }>;
}

interface Filter {
  name: string;
  code: string;
}
@Component({
  selector: 'app-add-clause',
  templateUrl: './add-clause.component.html',
  styleUrls: ['./add-clause.component.css']
})
export class AddClauseComponent implements OnInit {

  selectedOption: any;
  IsShownTQLeaderView: boolean = false;
  IsClauseDropDownShown: any;
  fileName = '';
  IsFilterShown: any;
  showError: boolean = false;
  clauseMasterDropDownList: any;
  formData: FormData = new FormData();
  clauseListWithDetails: any[] = [];
  FirmId: any;
  IsLoadingResults: any;
  ClauseDetailsArray!: FormArray;
  ClauseDetailsForm!: FormGroup;
  checkClauseExpand: any;
  clauseTypeList: any;
  values: Filter[] | undefined;
  selectedClause: any;
  formGroup: any;
  AttachDict: any[] = [];
  IsEditable: any;
  private readonly originalClauseStates = new Map<string, string>();
  constructor(public dialogRef: MatDialogRef<AddClauseComponent>,
    private _dialog: MatDialog,

    private fb: FormBuilder, protected _global: GlobalVariables,
    @Inject(MAT_DIALOG_DATA) public _data: DialogData, private _commonService: CommonService, private _dataService: DataService) {
    this.ClauseDetailsForm = this.fb.group({
      ClauseDetailsArray: this.fb.array([]),


    });

  }

  ngOnInit(): void {
    this.values = [
      { name: 'Modified', code: 'M' },
      { name: 'Delete', code: 'D' },
      { name: 'Add SubClause', code: 'S' },
      { name: 'No Change', code: 'N' },
    ];
    this.IsFilterShown = false;
    this.formGroup = new FormGroup({
      selectedClause: new FormControl<Filter | null>(null)
    });

    this.IsEditable = this._data.IsFormEditable;
    if (this._data.IsTQLLeader) {
      this.IsClauseDropDownShown = false;
      this.IsShownTQLeaderView = true;
    }
    if (this._data.IsSingleValue == true) {
      if (this._data.ClauseList.length > 0 && this.checkValueIsNullOrEmptyOrUndefined(this._data.CombineListOfData)) {
        this.IsFilterShown = true;

        this.selectedOption = this._data.ClauseList[0].ClauseNo;
        var detailsOfClauseList = this._data.ClauseList[0].ClauseDetailsList;
        if (this._data.IsSingleValue == true) {
          if (this._data.ClauseList.length > 0 && this.checkValueIsNullOrEmptyOrUndefined(this._data.CombineListOfData)) {
            this.IsFilterShown = true;
            this.selectedOption = this._data.ClauseList[0].ClauseNo;
            var detailsOfClauseList = this._data.ClauseList[0].ClauseDetailsList;

            // Remove duplicates based on ClauseNumber
            detailsOfClauseList = detailsOfClauseList.filter((clause: any, index: number, self: any[]) =>
              index === self.findIndex((c: any) => c.ClauseNumber === clause.ClauseNumber)
            );

            // Set the values based on ClauseRadioType
            detailsOfClauseList.forEach((clause: any) => {
              if (clause.ClauseRadioType === '1') {
                clause.ClauseRadioTypeText = 'Modify Clause';
              } else if (clause.ClauseRadioType === '2') {
                clause.ClauseRadioTypeText = 'Delete Clause';
              } else if (clause.ClauseRadioType === '3') {
                clause.ClauseRadioTypeText = 'No Change';
              } else if (clause.ClauseRadioType === '4') {
                clause.ClauseRadioTypeText = 'Add Clause/Sub Clause';
              }
              // Clear TQComments display for TQ Approver/Admin when clause has no status (after requestor edit/submit)
              if ((this._global.IsTQApprover || this._global.IsAdmin) && !clause.ClauseStatus) {
                clause.TQComments = '';
              }
            });

            this.clauseListWithDetails = detailsOfClauseList;
            this.IsClauseDropDownShown = false;
          } else {
            this._data.IsShownApprovalButtons = false;
            this._data.IsFormEditable = false;
            this.IsFilterShown = true;
            this.selectedOption = "";
            this.clauseListWithDetails = this._data.CombineListOfData;
            this.IsClauseDropDownShown = false;
          }
        }
        this.IsClauseDropDownShown = false;

      }
      else {
        this._data.IsShownApprovalButtons = false;
        this._data.IsFormEditable = false;
        this.IsFilterShown = true;
        this.selectedOption = "";
        this.clauseListWithDetails = this._data.CombineListOfData;
        this.IsClauseDropDownShown = false;

      }
    }
    else {
      this.IsClauseDropDownShown = true;
      this.ClauseDetailsArray = this.fb.array([]);
      this.FirmId = this._data.FirmID;
      this._commonService.BindDropDown('ClauseRange').subscribe((result: any) => {

        if (this._data.ClauseList.length > 0) {
          this._data.ClauseList.forEach((value: any, index: any) => {
            result.forEach((resvalue: any, resindex: any) => {
              if (value.ClauseNo == resvalue.label && value.IsActive == true) {
                result.splice(resindex, 1)
              }
            });

          });
        }
        this.clauseMasterDropDownList = result;


      });

      this._commonService.BindDropDown('ClauseType').subscribe(result => {
        this.clauseTypeList = result;
      });

    }


    // this.selectedOption = '3';
    this.captureOriginalClauseStates();
  }
  // OpenDialog(name: string , data :any) {
  //   const dialogRef = this._dialog.open(FileUploadComponent,
  //     {
  //       disableClose: true,
  //       width: '40%',
  //       data: { fieldName: name, Count: 1, Attachment: [], 
  //         IsFormEditable: this.IsEditable, IsAttachmentEnable: true , ScreenName: "AddClauseAttachment" }
  //     });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result !== undefined) {
  //       if(result.Attachment.length > 0)  {
  //         data.AttachmentName = result.Attachment[0].Value;
  //       }
  //       this.AttachDict = this.AttachDict.filter((x: { Key: any; }) => x.Key !== result.fieldName);
  //       this.AttachDict.push({ 'Key': result.fieldName, 'Value': result.Attachment });

  //     }
  //   });
  // }
  removeAttachment(value: string) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.AttachDict)) {
      this.AttachDict.forEach((element: any, index: any) => {
        if (element.Key == value) {
          this.AttachDict.splice(index, 1);

        }
      });

    }
  }



  onDownload(data: any) {

    // if(this._data.IsShownApprovalButtons){
    //   return;
    // }

    if (this.checkValueIsNullOrEmptyOrUndefined(data) &&
      this.checkValueIsNullOrEmptyOrUndefined(data.BlobId) &&
      this.checkValueIsNullOrEmptyOrUndefined(data.ClauseGTCID)) {
      alert("Something is wrong with the attachment or attachment found");
      return;
    }

    const downloadURL = 'Attachment/DownloadAllAttachmentByName';
    const attachment = { AttachmentName: data.BlobId, ScreenName: 'Clauses' };
    this._dataService.PostDownload(downloadURL, attachment).subscribe((x: any) => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, data.AttachmentName);
    },
      (error: any) => {
        console.log(error);
        ////this.alertService.notify('error','Error!',error.error.Message);
      });
  }
  onFileSelected(event: any, data: any, fileInput: HTMLInputElement) {
    if (event.target.files.length > 0) {
      this.IsLoadingResults = true;
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 10;
      const maxLengthForClause = 1024 * 1024 * 2;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();

      const validExtensions = ['docx', 'doc', 'pdf', 'zip', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'msg'];

      if (validExtensions.includes(fileExtension)) {
        if (file.size > maxLengthForClause) {
          this.IsLoadingResults = false;
          alert('File size can not be more than 2 mb.');
          fileInput.value = '';
          return;
        }

        this.formData = new FormData();
        this.formData.append('Attachments', file, file.name);

        this._dataService.postfile('Attachment/UploadAttachment/Attachments', this.formData)
          .subscribe(
            (path: any) => {
              if (!this.checkValueIsNullOrEmptyOrUndefined(path['RequestMessage'])) {
                data.AttachmentName = path['RequestMessage'];
                data.BlobId = path['BlobId'];
              }
            },
            (error) => {
              this.IsLoadingResults = false;
            },
            () => {
              this.IsLoadingResults = false;
              // ✅ Reset the file input so the same file can be selected again
              fileInput.value = '';
            }
          );
      } else {
        this.IsLoadingResults = false;
        alert('Please browse valid extensions.');
        fileInput.value = '';
      }
    }
  }

  radioChange(event: any) {

  }
  UploadAttachment(event: any) {

  }
  onDeleteAttachment(data: any) {

    if (this.checkValueIsNullOrEmptyOrUndefined(data) &&
      this.checkValueIsNullOrEmptyOrUndefined(data.BlobId) &&
      this.checkValueIsNullOrEmptyOrUndefined(data.ClauseGTCID)) {
      alert("Something is wrong with the attachment or attachment found");
      return;
    }

    const attachmentNameID = data.BlobId;
    const downloadURL = 'Attachment/DeleteAttachment/' + attachmentNameID + '/' + data.AttachmentName;
    this._dataService.GetData(downloadURL).subscribe((x: any) => {
      alert(x['RequestMessage']);
      if (x['RequestIsSuccess']) {
        data.AttachmentName = '';
        data.BlobId = '';
        data.Attachment = [];
        this.removeAttachment(data.ClauseGTCID);
      }
    },
      (error: any) => {
        console.log(error);
        ////this.alertService.notify('error','Error!',error.error.Message);
      });
  }
  proposedDescChange(event: any, data: any) {
    var d = event;
    // this.clauseListWithDetails.array.forEach((element: any) => {

    //   if(element.ClauseID == data.ClauseID)
    //   {
    //     const words1 = element.Description.split(' ');
    //     const words2 = element.ProposedDesc.split(' ');

    //     let modifiedHighlightedText = '';

    //     const maxLength = Math.max(words1.length, words2.length);

    //     for (let i = 0; i < maxLength; i++) {
    //       const word1 = words1[i] || '';
    //       const word2 = words2[i] || '';

    //       if (word1 === word2) {
    //         modifiedHighlightedText += word2 + ' ';
    //       } else {
    //         modifiedHighlightedText +=
    //           '<del class="CompareDelete">' +
    //           word1 +
    //           '</del>' +
    //           '<span class="CompareAdd">' +
    //           word2 +
    //           '</span> ';
    //       }
    //     }

    //     this.modifiedText = modifiedHighlightedText.trim();
    //   }
    // });
  }
  onFilterchange(event: any) {

    var value = event.value.name;
    if (!this.checkValueIsNullOrEmptyOrUndefined(value)) {
      if (value == 'Modified') { //1

        this.clauseListWithDetails.sort((s: any) => {

          const name1 = s;
          if (name1.ClauseRadioType == '1') {
            return -1;
          }
          else {
            return 1
          }
        });

      }
      else if (value == 'Add SubClause')//4
      {
        this.clauseListWithDetails.sort((s: any) => {

          const name1 = s;
          if (name1.ClauseRadioType == '4') {
            return -1;
          }
          else {
            return 1
          }
        });

      }
      else if (value == 'No Change')//3
      {
        this.clauseListWithDetails.sort((s: any) => {

          const name1 = s;
          if (name1.ClauseRadioType == '3') {
            return -1;
          }
          else {
            return 1
          }
        });

      }
      else if (value == 'Delete')//2
      {
        this.clauseListWithDetails.sort((s: any) => {

          const name1 = s;
          if (name1.ClauseRadioType == '2') {
            return -1;
          }
          else {
            return 1
          }
        });

      }
    }
  }
  getClauseDetails(event: any) {
    this.IsLoadingResults = true;
    var clauseValues = event.value.label.replace("Clause ", "");
    if (!this.checkValueIsNullOrEmptyOrUndefined(clauseValues)) {
      this._dataService.get('TaxGTC/GetClauseMasterDetails', this.FirmId, clauseValues).subscribe((data: any) => {
        // let rentObject = data.map((ct: any) => this.mapRent(ct));
        this.IsLoadingResults = false;

        if (!this.checkValueIsNullOrEmptyOrUndefined(data)) {
          // this.clauseListWithDetails = Object.assign(new ClauseMasterDetails(), data);
          this.clauseListWithDetails = data;

        }
      });
      // this.ClauseDetailsForm.controls['ClauseDetailsArray'].setValue(this.ClauseDetailsArray);
    }
  }
  onNoClick() {
    this.dialogRef.close();
    document.body.classList.remove("cdk-global-scrollblock");
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.clauseListWithDetails)) {
      this.clauseListWithDetails.sort((a: any, b: any) => a.ClauseID - b.ClauseID)

    }
  }
  OnApprovalStatusChange(event: any, number: any) {
    let element = this.clauseListWithDetails.find((element: any) => !this.checkValueIsNullOrEmptyOrUndefined(element.ClauseID) && element.ClauseID == event);

    if (element) {
      if (number == 1) {
        element.ClauseStatusName = "Approved";

        alert("Clause has been Approved Successfully")
      }
      else if (number == 2) {
        element.ClauseStatusName = "Rejected";

        alert("Clause has been Rejected Successfully.")
      }
      else if (number == 3) {
        element.ClauseStatusName = "PushBack";

        alert("Clause has been PushedBack Successfully.")
      }
      // Replace or modify data
      element.ClauseStatus = number;
    }
  }
  HighListChagnesInProposedClause(ListClause: any) {
    if (ListClause != null) {
      for (var j = 0; j < ListClause.length; j++) {
        if (!this.checkValueIsNullOrEmptyOrUndefined(ListClause[j].ProposedDesc))
          if (
            ListClause[j].Description != null &&
            ListClause[j].Description != undefined
          ) {
            var dmp = new DiffMatchPatch.diff_match_patch();

            var diff = dmp.diff_main(
              ListClause[j].Description,
              ListClause[j].ProposedDesc
            );

            dmp.diff_cleanupSemantic(diff);
            dmp.diff_cleanupEfficiency(diff);

            let html = dmp.diff_prettyHtml(diff);
            let styledHtml = html.replace(/<del style="background:#ffe6e6;">/g, '<del class="CompareDelete">')
              .replace(/<ins style="background:#e6ffe6;">/g, '<ins class="CompareAdd">');
            ListClause[j].ProposedByClientDesc = styledHtml;
          }
      }
    }
  }
  OnSave() {

    if (this.clauseListWithDetails.length > 0) {

      this.showError = this.clauseListWithDetails.every(item => item.ClauseRadioType === '3') && this._data.RecordStatus !== 7;
      if (this.showError) {
        alert("Please select at least one clause for modification, deletion, or addition.");
        return;
      }
      let clauseNumber = "";
      this.clauseListWithDetails.forEach((element: any) => {

        if (!this.checkValueIsNullOrEmptyOrUndefined(element.ClauseRadioType)) {
          if (element.ClauseRadioType == '1') {
            element.ClauseActionName = "Modified";
            if (this.checkValueIsNullOrEmptyOrUndefined(element.ProposedDesc)
              || this.checkValueIsNullOrEmptyOrUndefined(element.GCOComment)
              || this.checkValueIsNullOrEmptyOrUndefined(element.RiskMitigationActionPlan)
              || this.checkValueIsNullOrEmptyOrUndefined(element.SpecificBusinessCase)) {
              clauseNumber += element.ClauseNumber + ',';

            }
          }
          if (element.ClauseRadioType == '2') {
            element.ClauseActionName = "Drop Clause";
            if (this.checkValueIsNullOrEmptyOrUndefined(element.GCOComment)
              || this.checkValueIsNullOrEmptyOrUndefined(element.RiskMitigationActionPlan)
              || this.checkValueIsNullOrEmptyOrUndefined(element.SpecificBusinessCase)) {
              clauseNumber += element.ClauseNumber + ',';
            }

          } if (element.ClauseRadioType == '4') {
            element.ClauseActionName = "Add SubClause";
            if (this.checkValueIsNullOrEmptyOrUndefined(element.SubClauseDec) ||
              this.checkValueIsNullOrEmptyOrUndefined(element.ProposedDesc)
              || this.checkValueIsNullOrEmptyOrUndefined(element.GCOComment)
              || this.checkValueIsNullOrEmptyOrUndefined(element.RiskMitigationActionPlan)
              || this.checkValueIsNullOrEmptyOrUndefined(element.SpecificBusinessCase)) {
              clauseNumber += element.ClauseNumber + ',';
            }

          }

        }
      });
      if (!this.checkValueIsNullOrEmptyOrUndefined(clauseNumber)) {
        alert("Please complete all required details in:-" + clauseNumber);
        return;

      }
      else {
        this.HighListChagnesInProposedClause(this.clauseListWithDetails);
        const isRequestor = !this._global.IsTQApprover && !this._global.IsAdmin && !this._global.IsTQLeader;
        const isAdminOnPartiallyApproved = this._global.IsAdmin && (this._data.RecordStatus == 7 || this._data.RecordStatus == 2);
        if (isRequestor || isAdminOnPartiallyApproved) {
          this.clauseListWithDetails.forEach((clause: any) => {
            const originalState = this.originalClauseStates.get(this.getClauseStateKey(clause));
            const isNewClause = this.checkValueIsNullOrEmptyOrUndefined(clause.ClauseGTCID);
            clause.IsEditedByRequestor = isNewClause || originalState !== this.getClauseState(clause);
          });
        }
        this.dialogRef.close(this.clauseListWithDetails);

      }
      //         const words1 = element.Description.split(' ');
      //         const words2 = element.ProposedDesc.split(' ');

      //         let modifiedHighlightedText = '';

      //         const maxLength = Math.max(words1.length, words2.length);

      //         for (let i = 0; i < maxLength; i++) {
      //           const word1 = words1[i] || '';
      //           const word2 = words2[i] || '';

      //           if (word1 === word2) {
      //             modifiedHighlightedText += word2 + ' ';
      //           } else {
      //             modifiedHighlightedText +=
      //               '<del class="CompareDelete">' +
      //               word1 +
      //               '</del>' +
      //               '<span class="CompareAdd">' +
      //               word2 +
      //               '</span> ';
      //           }
      //         }

      //         element.ProposedByClientDesc = modifiedHighlightedText.trim();
      //       }
      //     });

    }


  }
  //6. TQ Comments Processed Without Action-- Changes By Rehan For Issue -- INTaxGTC Defects by Shipra Mam
  private validateClauseActionsBeforeDone(): boolean {
    const pendingClauseNumbers = this.clauseListWithDetails
      .filter((clause: any) =>
        clause &&
        !this.checkValueIsNullOrEmptyOrUndefined(clause.ClauseRadioType) &&
        (clause.ClauseRadioType == '1' || clause.ClauseRadioType == '2' || clause.ClauseRadioType == '4') &&
        this.checkValueIsNullOrEmptyOrUndefined(clause.ClauseStatus)
      )
      .map((clause: any) => clause.ClauseNumber)
      .filter((clauseNumber: any, index: number, self: any[]) => self.indexOf(clauseNumber) === index);

    if (pendingClauseNumbers.length > 0) {
      alert('Please approve, reject, or push back the following clause(s): ' + pendingClauseNumbers.join(','));
      return false;
    }

    return true;
  }

  OnDoneClick() {
    if (!this.validateClauseActionsBeforeDone()) {
      return;
    }

    this.dialogRef.close(this.clauseListWithDetails);
  }
  //6. TQ Comments Processed Without Action-- Changes By Rehan For Issue -- INTaxGTC Defects by Shipra Mam
  onSubmit() {

  }
  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }

  openClauseAuditTrail(data: any) {
    if (this.checkValueIsNullOrEmptyOrUndefined(data.ClauseGTCID)) {
      alert('No audit trail available for this clause.');
      return;
    }
    this._dialog.open(ClauseAuditTrailComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: '85vh',
      panelClass: 'audit-dialog-container',
      disableClose: false,
      data: {
        clauseGTCId: data.ClauseGTCID,
        clauseNumber: data.ClauseNumber
      }
    });
  }

  canRequestorEditClause(data: any): boolean {
    const isRequestor = !this._global.IsTQApprover && !this._global.IsAdmin && !this._global.IsTQLeader;
    return isRequestor && this._data.IsFormEditable;
  }

  canEditClauseAction(data: any): boolean {
    if (this._global.IsAdmin) {
      // Admin follows the requestor permission only while creating a brand-new GTC request.
      const canCreateNewRequest = this._data.IsNewRequest && this._data.IsFormEditable;
      return canCreateNewRequest ||
        (this._data.IsFormEditable && (this._data.RecordStatus == 6 || this._data.RecordStatus == 7));
    }

    return this.canRequestorEditClause(data);
  }

  canEditTQComments(data: any): boolean {
    const isNotNoChange = data.ClauseRadioType != '3' && data.ClauseRadioType != 3;
    const isRequestor = !this._global.IsTQApprover && !this._global.IsAdmin && !this._global.IsTQLeader;
    
    // TQ Comments is always frozen/non-editable for requestors
    if (isRequestor) {
      return false;
    }
    
    // TQ Approver can edit TQ Comments for all clause statuses (approved, rejected, pushback) until partially approved
    if (this._data.IsShownApprovalButtons && isNotNoChange) {
      return true;
    }
    return false;
  }

  isClauseFieldDisabled(data: any): boolean {
    if (this.IsShownTQLeaderView) return true;
    if (this._global.IsTQApprover) return true;
    if (this._global.IsAdmin && (this._data.RecordStatus == 6 || this._data.RecordStatus == 7)) return false;
    if (!this._global.IsAdmin && !this._global.IsTQLeader) return !this.canRequestorEditClause(data);
    if (this._data.IsShownApprovalButtons) return true;
    if (data.ClauseStatus == 1) return true;
    return false;
  }

  private captureOriginalClauseStates(): void {
    this.clauseListWithDetails.forEach((clause: any) => {
      if (!this.checkValueIsNullOrEmptyOrUndefined(clause.ClauseGTCID)) {
        this.originalClauseStates.set(this.getClauseStateKey(clause), this.getClauseState(clause));
      }
    });
  }

  private getClauseStateKey(clause: any): string {
    return String(clause.ClauseGTCID ?? clause.ClauseID ?? clause.ClauseNumber);
  }

  private getClauseState(clause: any): string {
    return JSON.stringify({
      ClauseRadioType: clause.ClauseRadioType,
      ProposedDesc: clause.ProposedDesc,
      SubClauseDec: clause.SubClauseDec,
      GCOComment: clause.GCOComment,
      RiskMitigationActionPlan: clause.RiskMitigationActionPlan,
      SpecificBusinessCase: clause.SpecificBusinessCase
    });
  }

}
